<template>
    <div class="w-100 h-100 error-state d-flex justify-content-center align-items-center flex-grow-1 flex-column">
        <h3>Error</h3>
        <h6 class="mb-3">
            <span> An error occurred while {{ action }} {{ title }}. </span> Please try again or submit a ticket for
            assistance.
        </h6>
        <button class="btn btn-primary" @click="tryAgain?.()" v-if="showTryAgain">Try Again</button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        tryAgain: { type: Function, default: null },
        title: { type: String, default: "" },
        showTryAgain: { type: Boolean, default: false },
        action: { type: String, default: "loading" }
    }
});
</script>
